import React from 'react';
import PropTypes from 'prop-types';
import './FormDetailSkeleton.css';

const FormDetailSkeleton = ({
  titleLines = 1,
  fieldRows = 4,
  columns = 2,
  showFooter = true,
  className = ''
}) => {
  return (
    <div className={`fds-card ${className}`.trim()}>
      <div className="fds-header">
        {Array.from({ length: Math.max(1, titleLines) }).map((_, idx) => (
          <span key={`fds-title-${idx}`} className="fds-shimmer fds-line fds-title" />
        ))}
      </div>

      <div
        className="fds-grid"
        style={{ gridTemplateColumns: `repeat(${Math.max(1, columns)}, minmax(0, 1fr))` }}
      >
        {Array.from({ length: Math.max(1, fieldRows) * Math.max(1, columns) }).map((_, idx) => (
          <div key={`fds-field-${idx}`} className="fds-field">
            <span className="fds-shimmer fds-line fds-label" />
            <span className="fds-shimmer fds-input" />
          </div>
        ))}
      </div>

      {showFooter ? (
        <div className="fds-footer">
          <span className="fds-shimmer fds-btn" />
          <span className="fds-shimmer fds-btn" />
        </div>
      ) : null}
    </div>
  );
};

FormDetailSkeleton.propTypes = {
  titleLines: PropTypes.number,
  fieldRows: PropTypes.number,
  columns: PropTypes.number,
  showFooter: PropTypes.bool,
  className: PropTypes.string
};

export default FormDetailSkeleton;
